import React, { useState, useEffect } from 'react'
import { getData } from '../../../actions/servicesHttp'
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup, /* ,
  Polyline */
  LayersControl,
  LayerGroup
} from 'react-leaflet'
import { config } from '../../../config'
import ReturnButton from '../../../components/generals/buttonReturn'
import { useParams, useNavigate } from 'react-router-dom'
import styles from '../../../css/devices/LocationHistory.module.css'
import Header from '../../../components/generals/header'
import iconMap from '../../../components/generals/iconMap'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import stylesIndex from '../../../css/Index.module.css'
import { useTranslation } from 'react-i18next'

export default function LocationHistory () {
  const { id } = useParams()
  const [data, setData] = useState([])
  const { t } = useTranslation('map')
  const navigate = useNavigate()
  // const [line, setLine] = useState([])

  useEffect(() => {
    const getDataLocationsDevice = async () => {
      const { data } = await getData('device/locations', id, navigate)
      if (data) {
        // const result = data.map((element) => [element.lat, element.lon])
        setData(data)
        // setLine(result)
      }
    }
    getDataLocationsDevice()
  }, [id])

  if (data !== null) {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Header title={t('label6')} />
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <ReturnButton redirect={`device/${id}`} />
          </div>

          <MapContainer id="mapDevice" className={styles.mapHistory} center={config.map.center} zoom={config.map.zoom_specific} scrollWheelZoom={true}>
            {/* <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/> */}
            {/* <Polyline positions={line} opacity={0.5}></Polyline> */}
            {data && data.map((element, key) => element.lat === null || element.lon === null
              ? null
              : (
                  <Marker key={key} position={[element.lat, element.lon, element.acc]} icon={iconMap}>
                    <Popup>
                      <div className={styles.popup}>
                        <span>{t('label3')} { element.place
                          ? element.place
                          : [element.lat, ',', element.lon]}
                        </span>
                        <span>{t('label4')} {formatDate(element.date)} </span>
                        <span>{t('label5')} {element.type} </span>
                      </div>
                    </Popup>
                  </Marker>
                )
            )}
            <LayersControl position="topright">
              <LayersControl.BaseLayer checked name={t('baseLayers.base1')}>
                <TileLayer
                  attribution='&copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ'
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name={t('baseLayers.base2')}>
                {/* Capa de topografía */}
                <TileLayer
                  attribution='Tiles &copy; Esri &mdash; Esri, USGS, NOAA'
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name={t('baseLayers.base3')}>
                <LayerGroup>
                  {/* Capa de imágenes satelitales */}
                  <TileLayer
                    // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    attribution='&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Source: Esri, Maxar, Earthstar Geographics'
                    />
                    {/* Capa de calles */}
                    <TileLayer
                      url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}"
                      attribution='&copy; <a href="https://www.esri.com/">Esri</a> — Roads & Transportation'
                    />
                </LayerGroup>
              </LayersControl.BaseLayer>
            </LayersControl>
          </MapContainer>
        </div>
      </div>)
  } else {
    <div></div>
  }
}
